import { useQuery } from '@tanstack/react-query';
import { PolicyAPIResponseMapper, PolicyInterestMapper } from '@/api/mapper/policy';
import { getMemberPolicies, getPolicy, getPolicyInterest } from '@/api/service/policy';

export const policyKeys = {
  all: ['policies'] as const,
  byMember: (memberId: string) => [...policyKeys.all, 'member', memberId] as const,
  detail: (policyId: string) => [...policyKeys.all, 'detail', policyId] as const,
  interest: (policyId: string) => [...policyKeys.all, 'interest', policyId] as const,
};

/** One member's policies, for the member drawers. */
export function useMemberPoliciesQuery(memberId?: string | null, enabled = true) {
  return useQuery({
    queryKey: policyKeys.byMember(memberId ?? 'none'),
    queryFn: async () => (await getMemberPolicies(Number(memberId))).map(PolicyAPIResponseMapper),
    enabled: enabled && Boolean(memberId),
  });
}

export function usePolicyQuery(policyId?: string | null, enabled = true) {
  return useQuery({
    queryKey: policyKeys.detail(policyId ?? 'none'),
    queryFn: async () => PolicyAPIResponseMapper(await getPolicy(Number(policyId))),
    enabled: enabled && Boolean(policyId),
  });
}

export function usePolicyInterestQuery(policyId?: string | null, enabled = true) {
  return useQuery({
    queryKey: policyKeys.interest(policyId ?? 'none'),
    queryFn: async () => {
      const response = await getPolicyInterest(Number(policyId));
      return response.data.map(PolicyInterestMapper);
    },
    enabled: enabled && Boolean(policyId),
  });
}
